import React from 'react';
import fotoPersonal from './../images/images-master/images-personal-svg/foto-150.svg'
import TitleAlt from './../atoms/TitleAlt.jsx'

const PresentationCard = () => (
    <div className="container-about-master">
        <section className="content-presentation">
            <img src={fotoPersonal} alt={TitleAlt} />
            <div className="content-text-master">
                <p>Eliud César</p>
                <p>16 años</p>
                <p>Ometepec, Guerrero</p>
                <p>Estudiante autodidacta</p>
            </div>
        </section>
    </div>
)

export default PresentationCard;
